import React, { useState } from "react";
import DropDown from "../reusable/DropDown";
import ShadeBackgound from "../reusable/ShadeBackgound";
import ArrowDropDown from "../../assets/responsiveIcons/ArrowDropDown";
import { useConnectWallet, useWallets, useSetChain } from "@web3-onboard/react";
function Etherium({ networks = [], setNetworks }) {
  const [isOpen, setIsOpen] = useState(false);
  const [{ chains, connectedChain, settingChain }, setChain] = useSetChain();


  const handleOnClick = async(e) => {
    let changeSuccess= false;
    try{
      changeSuccess= await setChain ({chainId:e.target.chainId});
     }catch(e){
      console.log (console.log("error occured during network shift") );
      return  ;
    }
    if(!changeSuccess) return;
    if (!e.target || !e.target.name) return;
    for (let i = 0; i < networks.length; i++) {
      if (networks[i].name === e.target.name) {
        
        networks[i].isSelectedAsFrom = true;

        if (networks[i].isSelectedAsTo) {
          networks[i].isSelectedAsTo = false;
          networks.filter(
            (el) => !el.isSelectedAsFrom
          )[0].isSelectedAsTo = true;
        }
      } else {
        networks[i].isSelectedAsFrom = false;
      }
    }
    setNetworks([...networks]);
  };

  const findSelectedNetwork = () => {
    try{
      for (let i = 0; i < networks.length; i++) {
        const element = networks[i];
  
        if (element.isSelectedAsFrom) {
          return element;
        }
      }
      return null;
    }catch(e){
      // console.log(e)

    }
   
  };

  const filterNetworksForFromSection = () => {
    try{
      const arr = [];
    for (let i = 0; i < networks.length; i++) {
      const element = networks[i];
      if (element.isSelectedAsTo) {
        // continue;
      }
      if (element.isSelectedAsFrom) {
        element.isSelected = true;
      } else {
        element.isSelected = false;
      }
      arr.push(element);
    }
    return arr;
    }catch(e){
      // console.log(e)
    }
    
  };

  return (
    <div>
      <div className="relative" onClick={() => setIsOpen(!isOpen)}>
        <div className="w-11 m-1 flex justify-between text-white items-center">
          {/* <img src={Eth} alt="Eth" /> */}
          {findSelectedNetwork().icon}
          <ArrowDropDown />
        </div>
        {/* <p className="bg-violet-600">{findSelectedNetwork().label}</p> */}
        <DropDown
          top={2.51}
          left={-0.2}
          selected={findSelectedNetwork().name}
          items={filterNetworksForFromSection()}
          isOpen={isOpen}
          onClick={handleOnClick}
          className=""
        />
      </div>
      {isOpen && (
        <ShadeBackgound
          opacity={0.2}
          onClik={() => isOpen && setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default Etherium;
